.field {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  min-width: 0;
}

.labelRow {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--space-3);
}

.label {
  color: var(--color-text-primary);
  font-size: var(--type-label-size);
  line-height: var(--type-label-line);
  font-weight: var(--weight-medium);
}

.disabled .label {
  color: var(--color-text-disabled);
}

.required {
  margin-inline-start: 2px;
  color: var(--color-error);
}

.optional {
  margin-inline-start: var(--space-1);
  color: var(--color-text-helper);
  font-weight: var(--weight-regular);
}

.hint {
  color: var(--color-text-helper);
  font-size: var(--type-body-sm-size);
  line-height: var(--type-body-sm-line);
}

.error {
  display: flex;
  align-items: flex-start;
  gap: var(--space-1);
  color: var(--color-error);
  font-size: var(--type-body-sm-size);
  line-height: var(--type-body-sm-line);
}

.error svg {
  margin-top: 2px;
  fill: var(--color-error-icon);
}

.messages {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.messages:empty {
  display: none;
}

.fieldset {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
}

.legend {
  padding: 0;
  margin-bottom: var(--space-2);
  color: var(--color-text-primary);
  font-size: var(--type-label-size);
  line-height: var(--type-label-line);
  font-weight: var(--weight-medium);
}
